/* eslint-disable */
import React, { useEffect } from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const usedGlp = useStore((state) => state.usedGlp);
  const setUsedGlp = useStore((state) => state.setUsedGlp);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2' style={{ padding: '0 20px' }}>
          {t('onboarding.usedGlp.title')}
        </Title>
        <Text size='m' medium className='description'>
          {t('onboarding.usedGlp.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={usedGlp}
          onChange={(value: string) => {
            setUsedGlp(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'used-glp',
              answer: value,
            });
            setTimeout(() => {
              onNext();
            }, 150);
          }}
        >
          <Option value={'Currently using'}>{t('onboarding.usedGlp.options.currently')}</Option>
          <Option value={'Used before'}>{t('onboarding.usedGlp.options.used')}</Option>
          <Option value={'Never used'}>{t('onboarding.usedGlp.options.never')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;

